import styled from "styled-components";
import { useState } from "react";

const MatchStat = ({ homeScore, awayScore, statName }) => {
  return (
    <>
      <Container>
        <Stat>{homeScore}</Stat>
        <StatTitle className="heading">{statName}</StatTitle>
        <Stat>{awayScore}</Stat>
      </Container>
    </>
  );
};
export default MatchStat;
const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
`;
const StatTitle = styled.div``;
const Stat = styled.div`
  font-weight: bold;
`;
